(function () {
  const BREAKPOINT = 767; // Ajusta si tu "mobile" en el tema usa otro breakpoint (p.ej. 989)
  const MQ = `(max-width: ${BREAKPOINT}px)`;
  const DEBUG = false; // Pon true si quieres ver logs en consola

  function log(...args) {
    if (DEBUG) console.log("[pdp-move]", ...args);
  }

  function apply(root) {
    const slot = root.querySelector("[data-mobile-options-slot]");
    const stack = root.querySelector("[data-actions-stack]");
    const optionsCell = root.querySelector(".etheryx-product-options");

    if (!slot || !stack || !optionsCell) {
      root.dataset.pdpMove = `missing:${!slot ? "slot" : ""}${!stack ? " stack" : ""}${!optionsCell ? " options" : ""}`.trim();
      return false;
    }

    // Placeholder para devolver el stack a su sitio exacto
    let placeholder = optionsCell.querySelector("[data-actions-placeholder]");
    if (!placeholder) {
      placeholder = document.createElement("span");
      placeholder.setAttribute("data-actions-placeholder", "true");
      placeholder.style.display = "none";

      // Insertar placeholder justo antes del stack, en su posición original
      stack.parentNode.insertBefore(placeholder, stack);
      log("placeholder created");
    }

    const isMobile = window.matchMedia(MQ).matches;

    if (isMobile) {
      // Mover el bloque entero al slot, si aún no está ahí
      if (stack.parentNode !== slot) {
        slot.appendChild(stack);
        log("moved to slot");
      }

      // Ocultar la columna original para que no deje huecos
      optionsCell.classList.add("is-moved-to-slot");
      root.dataset.pdpMove = "moved";
    } else {
      // Restaurar en desktop
      if (stack.parentNode !== optionsCell) {
        optionsCell.insertBefore(stack, placeholder.nextSibling);
        log("restored to options");
      }

      optionsCell.classList.remove("is-moved-to-slot");
      root.dataset.pdpMove = "restored";
    }

    return true;
  }

  function init(root) {
    if (!root) return;
    if (root.classList.contains("featured-product")) return; // evitar afectar a secciones de "featured product"

    root.dataset.pdpMove = "init";

    // 1) Aplicar varias veces al inicio (por si el tema "hidrata" tarde)
    let tries = 0;
    const pump = () => {
      tries++;
      const ok = apply(root);
      if (!ok && tries < 60) requestAnimationFrame(pump);
    };
    pump();

    // 2) Observar cambios: si t-product.js re-renderiza, re-aplicamos
    const mo = new MutationObserver(() => apply(root));
    mo.observe(root, { childList: true, subtree: true });

    // 3) Cambios de breakpoint
    const mql = window.matchMedia(MQ);
    const onChange = () => apply(root);
    if (mql.addEventListener) mql.addEventListener("change", onChange);
    else mql.addListener(onChange);

    log("init done");
  }

  function boot() {
    document.querySelectorAll("product-info.product-page").forEach(init);
  }

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();
